export default __webpack_public_path__ + "en.8c4986ee.svg";